package floris.graphics.models.dto.requests.contributor

import floris.graphics.models.domain.models.interfaces.DateAble
import floris.graphics.models.dto.requests.MediaFileDto
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ContributorDto(
    val id: String = "",
    val name: String = "",
    val website: String? = null,
    @SerialName("logo_media_file")
    val logoMediaFile: MediaFileDto? = null,
    val bio: String? = null,
    @SerialName("created_at")
    override val createdAt: String = "",
    @SerialName("updated_at")
    override val updatedAt: String = "",
): DateAble
